var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 8C22.448 8 22 7.553 22 7V3C22 2.448 21.551 2 21 2H17C16.448 2 16 1.553 16 1C16 0.447 16.448 0 17 0H21C22.654 0 24 1.346 24 3V7C24 7.553 23.552 8 23 8Z",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24H17C16.448 24 16 23.553 16 23C16 22.447 16.448 22 17 22H21C21.551 22 22 21.552 22 21V17C22 16.447 22.448 16 23 16C23.552 16 24 16.447 24 17V21C24 22.654 22.654 24 21 24Z",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 24H3C1.346 24 0 22.654 0 21V17C0 16.447 0.448 16 1 16C1.552 16 2 16.447 2 17V21C2 21.552 2.449 22 3 22H7C7.552 22 8 22.447 8 23C8 23.553 7.552 24 7 24Z",
    className: "fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8C0.448 8 0 7.553 0 7V3C0 1.346 1.346 0 3 0H7C7.552 0 8 0.447 8 1C8 1.553 7.552 2 7 2H3C2.449 2 2 2.448 2 3V7C2 7.553 1.552 8 1 8Z",
    className: "fill"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.00586,
    y: 6.53125,
    width: 11.6387,
    height: 11.1131,
    rx: 1.25,
    className: "stroke",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.953c3f8005e94170c04020fdd535822e.svg";
export { ForwardRef as ReactComponent };